export class MaxQuota {
    constructor(form) {
        this.form = form;
        this.element = form.querySelector("input#max-quota");
    }
    addToFormData(formData) {
        if (this.element.value) {
            formData.append(this.element.name, this.element.value);
        }
    }
    validate() {
        return true;
    }
}
